import { Field } from "formik";
import { FtextField } from "../../../../../components/common/FtextField";
import { useTranslation } from "react-i18next";

const ShurjoPayForm = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="displayGrid3">
        <FtextField
          type="text"
          label={t("userName")}
          name="settings.paymentGateway.shurjoPay.username"
          validation={true}
        />

        <FtextField
          type="password"
          label={t("password")}
          name="settings.paymentGateway.shurjoPay.password"
          validation={true}
        />

        <FtextField
          type="text"
          label={t("orderPerfix")}
          name="settings.paymentGateway.shurjoPay.orderPerfix"
          validation={true}
        />
      </div>

      <div className="displayGrid3">
        <div className="form-check mt-4">
          <Field
            className="form-check-input"
            type="checkbox"
            id="shurjoPay"
            name="settings.paymentGateway.providers.shurjoPay"
          />
          <label className="form-check-label" for="shurjoPay">
            {t("hasGateway")} <span className="text-danger ms-1">*</span>
          </label>
        </div>

        <div className="form-check mt-4">
          <Field
            className="form-check-input"
            type="checkbox"
            id="hasPG"
            name="settings.paymentGateway.hasPG"
          />
          <label className="form-check-label" for="hasPG">
            {t("hasPG")} <span className="text-danger me-4">*</span>
          </label>
        </div>
      </div>
    </>
  );
};

export default ShurjoPayForm;
